import { Box, styled } from '@mui/material';

export const ResourceSelectorContainer = styled(Box)`
  & > div {
    padding: 0 16px;
  }
  max-width: 400px;
  padding: 20px 0 0 0;
  height: 100vh;
`;

export const ResourceSelectorContent = styled(Box)`
  flex: 1;
  overflow-y: auto;
  padding: 0 16px 0 16px !important;
  height: calc(100vh - 20px - 24px - 15px - 44px - 53px);
`;
